export default __webpack_public_path__ + "static/media/replay.2e238260.svg";